import * as React from 'react';
import { WebPage } from '@grandvisionhq/analytics';
import { useProductLink } from '../../../utils/use-product-link.js';
import { useProductDetailContext } from '../../Context/ProductDetailContext.js';

const WebPageAnalytics = ()=>{
    const { activeVariant: { description , brand , sku , productType  } , product: { slug  } ,  } = useProductDetailContext();
    const variantUrl = useProductLink(slug, sku, productType);
    const productUrl = `${variantUrl}#product`;
    return /*#__PURE__*/ React.createElement(WebPage, {
        url: productUrl,
        pageType: "ProductDetail",
        name: brand,
        description: description
    });
};

export { WebPageAnalytics };
//# sourceMappingURL=WebPageAnalytics.js.map
